export enum TestResultStatusEnum {
    YES = 1,
    NO = 2, 
    UNSURE = 3
}

